module.exports = __webpack_public_path__ + "img/main-title.afbde285.png";